<template>
  <div class="bg-home">
    <carousel
      :loop="true"
      :perPage="1"
      :autoplayHoverPause="false"
      :paginationActiveColor="'#613A7D'"
      :autoplay="true"
      :autoplayTimeout="20000"
      :navigationEnabled="true"
      ref="carousel"
    >
      <slide v-for="(svg, index) in svgListFinal" :key="index">
        <div class="svg-container" v-html="svg"></div>
      </slide>
    </carousel>
  </div>
</template>

<style type="text/css">
.bg-home {
  margin: -70px -20px -50px;
}
.VueCarousel {
  background: #613a7d;
}
.VueCarousel-pagination {
  background: transparent;
  margin-top: -30px;
}
.VueCarousel-navigation-button {
  color: white !important;
  font-size: 4em;
  opacity: 0.9;
  text-shadow: 4px 4px 5px rgba(0, 0, 0, 0.3);
}
.VueCarousel-navigation-button:hover {
  color: #ebebeb !important;
}
.VueCarousel-navigation-button:active {
  color: #613a7d !important;
}
.VueCarousel-navigation--disabled {
  opacity: 0 !important;
}
.VueCarousel-navigation-prev {
  left: 80px !important;
}
.VueCarousel-navigation-next {
  right: 80px !important;
}
.VueCarousel-dot,
.VueCarousel-dot--active {
  margin-top: 0px !important;
  padding: 0 10px 10px;
}
.VueCarousel-pagination {
  z-index: 9;
  position: relative;
}

@media screen and (min-width: 768px) and (max-width: 900px) {
  .bg-home {
    margin: 0;
  }
}

@media screen and (min-width: 768px) and (max-width: 1279px) {
  .bg-home {
    margin: -60px -20px -50px;
  }
}

@media only screen and (max-width: 767px) {
  .bg-home {
    margin: -50px -20px;
  }
  .VueCarousel-pagination {
    background: transparent;
    margin-top: -30px;
  }
}

@media screen and (max-width: 479px) {
  .bg-home {
    margin: -20px 0 -50px;
  }
  .VueCarousel {
    width: calc(100% + 20px) !important;
    margin: 0 -10px;
  }
}
</style>

<script>
import { Carousel, Slide } from "vue-carousel";
import DocumentsEnum from "../../enum/documents";

export default {
  data() {
    return {
      isMobile: false,
      svgListFinal: []
    };
  },

  created() {
    this.isMobile = $(window).width() < 760;
    $(window).resize(() => {
      const wasMobile = this.isMobile;
      this.isMobile = $(window).width() < 760;
      if (wasMobile !== this.isMobile) {
        this.fetchDocuments();
      }
    });

    window.addEventListener("beforeunload", this.clearCache);
  },

  mounted() {
    this.fetchDocuments();
  },

  methods: {
    async fetchDocuments() {
      const cacheName = "svgCache";
      const filteredDocuments = DocumentsEnum.filter((document) => {
        return this.isMobile ? document.fileCategoryId === 6 : document.fileCategoryId === 7;
      });

      console.log(filteredDocuments, "filteredDocuments");
      const cache = await caches.open(cacheName);
      const svgArray = [];

      for (const doc of filteredDocuments) {
        let response = await cache.match(doc.urlDocumento);
        if (!response) {
          response = await fetch(doc.urlDocumento);
          if (response.ok) {
            await cache.put(doc.urlDocumento, response.clone());
          } else {
            console.error(`Falha ao buscar documento: ${doc.urlDocumento}`);
            continue;
          }
        }
        const svgContent = await response.text();
        svgArray.push(svgContent);
      }

      this.svgListFinal = svgArray;
    },

    async clearCache() {
      const cacheNames = await caches.keys();
      for (const name of cacheNames) {
        if (name === 'svgCache') {
          await caches.delete(name);
        }
      }
    }
  },

  components: {
    Carousel,
    Slide,
  },
};
</script>



// WEBPACK FOOTER //
// home.vue?4219fc54